<template>
    <div id="app">
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{ $t('Help') }} </v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-flex xs12 md12 sm12>
            <v-tabs
              style="width: 100%; height: 100%"
              dark=""
              v-model="active"
              color="info"
              slot="extension"
              slider-
            >
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#0"> {{ $t('Current') }} </v-tab>
              <v-tab href="#1"> {{ $t('Ticket') }} </v-tab>
              <v-tab-item :id="'0'">
                <v-container fluid grid-list-md>
                  <v-flex pb-3 xs12 sm12 md12>
                    <v-list subheader>
                      <v-list-tile
                        v-for="item in cariItems"
                        :key="item.title"
                        @click="openVideoDialog(item.url)"
                      >
                        <v-list-tile-content>
                          <v-list-tile-title
                            class="project overdue pl-2 gray--text font-weight-medium text-uppercase"
                          >
                            {{ item.title }}
                          </v-list-tile-title>
                        </v-list-tile-content>
  
                        <v-list-tile-action>
                          <v-icon color="red accent-2">videocam</v-icon>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list>
                  </v-flex>
                </v-container>
              </v-tab-item>
              <v-tab-item :id="'1'">
                <v-container fluid grid-list-md>
                  <v-flex pb-3 xs12 sm12 md12>
                    <v-list subheader>
                      <v-list-tile
                        v-for="item in biletItems"
                        :key="item.title"
                        @click="openVideoDialog(item.url)"
                      >
                        <v-list-tile-content>
                          <v-list-tile-title
                            class="project overdue pl-2 gray--text font-weight-medium text-uppercase"
                          >
                           <span color="grey lighten-1"> {{ item.title }} </span> 
                          </v-list-tile-title>
                        </v-list-tile-content>
  
                        <v-list-tile-action>
                          <v-icon color="red accent-2">videocam</v-icon>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list>
                  </v-flex>
                </v-container>
              </v-tab-item>
            </v-tabs>
          </v-flex>
        </v-layout>
      </v-card>
  
      <v-dialog v-if="videodialog" v-model="videodialog" max-width="800px">
        <v-card>
          <v-card-text>
            <iframe
              width="100%"
              height="500"
              :src="youtubeUrl"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            ></iframe>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        active: "",
        videodialog: false,
        youtubeUrl: null,
        cariItems: [
          {
            title: this.$t('Arkman-Next-Demo'),
            url: "https://www.youtube.com/embed/O-9dvTBSy8I?list=PLIeHwLek0GOeIoIUwHSUXZpnvX2Al8l3g",
          },
          {
            title: this.$t('Current-Card-Introduction-Process'),
            url: "https://www.youtube.com/embed/3Ve0qSD3R5c?list=PLIeHwLek0GOeIoIUwHSUXZpnvX2Al8l3g",
          },
          {
            title: this.$t('Current-Transaction-Entry'),
            url: "https://www.youtube.com/embed/DThNKj_33hg?list=PLIeHwLek0GOeIoIUwHSUXZpnvX2Al8l3g",
          },
        ],
        biletItems: [
          {
            title: this.$t('Arkman-Next-Demo'),
            url: "https://www.youtube.com/embed/O-9dvTBSy8I?list=PLIeHwLek0GOeIoIUwHSUXZpnvX2Al8l3g",
          },
          {
            title: this.$t('Ticket-Identification-Process-General-Tab'),
            url: "https://www.youtube.com/embed/d7uY_G26Y7k?list=PLIeHwLek0GOeIoIUwHSUXZpnvX2Al8l3gg",
          },
          {
            title: this.$t('Ticket-Introduction-Flight-Information-and-Amount-Information-Tab'),
            url: "https://www.youtube.com/embed/8eTojmxRm50?list=PLIeHwLek0GOeIoIUwHSUXZpnvX2Al8l3g",
          },
          {
            title: this.$t('Ticket-Promotion-Collection-Information-Tab'),
            url: "https://www.youtube.com/embed/o1g53JL_Opo?list=PLIeHwLek0GOeIoIUwHSUXZpnvX2Al8l3g",
          },
          {
            title: this.$t('Promoting-Tickets-Notes-Tab'),
            url: "https://www.youtube.com/embed/--YXGzjMAgE?list=PLIeHwLek0GOeIoIUwHSUXZpnvX2Al8l3g",
          },
          {
            title: this.$t('Introducing-Tickets-Special-Notes-Tab'),
            url: "https://www.youtube.com/embed/bvZL9_jC488?list=PLIeHwLek0GOeIoIUwHSUXZpnvX2Al8l3g",
          },
        ],
      };
    },
    methods: {
      openVideoDialog(val) {
        this.youtubeUrl = val;
        this.videodialog = true;
      },
    },
  };
  </script>
  
  <style>
  </style>